import React from "react";
import { connect } from "react-redux";

import MessagingContact from "../../types/core/MessagingContact";
import { IAppState } from "../../state/Store";
import {
    addRecipient,
    removeRecipient,
} from "../../state/system/Messaging";
import SelectorBox from "../selector/SelectorBox";

interface MessagingRecipientsProps {
    isSystem: boolean;
    broadcasting: boolean;
    contacts: Array<MessagingContact>;
    recipients: Array<MessagingContact>;
    addRecipient: (recipient: MessagingContact) => void;
    removeRecipient: (recipient: MessagingContact) => void;
}

class MessagingRecipients extends React.Component<MessagingRecipientsProps> {
    contactDisplay(item: MessagingContact) {
        return `${item.Display} (${item.Username})`;
    }

    render(): React.ReactNode {
        return (
            !this.props.isSystem &&
            !this.props.broadcasting && (
                <div className="inputForm col-pane">
                    <div className="flex">
                        <SelectorBox
                            className="col"
                            showName={false}
                            keyField="UserID"
                            displayField="Display"
                            displayFunc={item => this.contactDisplay(item)}
                            placeholder="To..."
                            source={this.props.contacts}
                            value={this.props.recipients}
                            onAdd={this.props.addRecipient}
                            onRemove={this.props.removeRecipient}></SelectorBox>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { messaging } = state.db;
    return {
        contacts: messaging.contacts,
        recipients: messaging.recipients,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addRecipient: (recipient: MessagingContact) => dispatch(addRecipient(recipient)),
        removeRecipient: (recipient: MessagingContact) =>
            dispatch(removeRecipient(recipient)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagingRecipients);
